import { ArrowLeftOutlined, ArrowRightOutlined } from "@mui/icons-material";
import { useState } from "react";
import { styled } from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSwipeable } from "react-swipeable";

const ImageSlider = ({ imageList }) => {
  const navigate = useNavigate();
  const [slideIndex, setSlideIndex] = useState(0);
  const handleClick = (direction) => {
    if (direction === "left") {
      setSlideIndex(slideIndex > 0 ? slideIndex - 1 : imageList.length - 1);
    } else {
      setSlideIndex(slideIndex < imageList.length - 1 ? slideIndex + 1 : 0);
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft: () => handleClick("right"),
    onSwipedRight: () => handleClick("left"),
    preventDefaultTouchmoveEvent: true,
    swipeDuration: Infinity,
  });

  return (
    <Container id="imageSlider" {...handlers}>
      <ArrowLeft direction="left" onClick={() => handleClick("left")}>
        <ArrowLeftOutlined />
      </ArrowLeft>
      <Wrapper slideIndex={slideIndex}>
        {imageList.map((item) => (
          <Slide key={item.id}>
            <ImageContainer>
              <Image src={`/img/portfolios/${item.image}`} />
            </ImageContainer>
            <InfoContainer>
              <Title>{item.category}</Title>
            </InfoContainer>
          </Slide>
        ))}
      </Wrapper>
      <ArrowRight direction="right" onClick={() => handleClick("right")}>
        <ArrowRightOutlined />
      </ArrowRight>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  position: relative;
  overflow: hidden;
  scroll-snap-align: center;
`;

const ArrowLeft = styled.div`
  width: 50px;
  height: 50px;
  background-color: #fff7f7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.2);
  }
`;

const ArrowRight = styled.div`
  width: 50px;
  height: 50px;
  background-color: #fff7f7;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  margin: auto;
  cursor: pointer;
  opacity: 0.5;
  z-index: 2;
  transition: all 0.5s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.2);
  }
`;

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  transition: all 1.5s ease;
  transform: translateX(${(props) => props.slideIndex * -100}vw);
`;

const Slide = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
`;

const ImageContainer = styled.div`
  position: absolute;
  background-color: #f5fbfd;
`;

const Image = styled.img`
  object-fit: cover;
  width: 100vw;
  @media (max-width: 768px) {
    height: 100vh;
  }
`;

const InfoContainer = styled.div`
  position: relative;
  width: 100%;
  top: 20%;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 65px;
  letter-spacing: 5px;
  color: white;
  text-align: center;
  font-family: "Kestrel";
  @media (max-width: 768px) {
    font-size: 35px;
  }
`;

const Description = styled.p`
  margin-bottom: 50px;
  font-size: 20px;
  font-weight: 500;
  text-align: end;
`;

const Button = styled.button`
  padding: 10px 50px;
  font-size: 20px;
  background-color: white;
  cursor: pointer;
`;

export default ImageSlider;
